import { useGetReAssessmentCategory } from "@/api/console/re-assessments/useGetReAssessmentCategory";
import AdminContentContainer from "@/components/AdminContentContainer";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import BottomBar from "@/components/BottomBar";
import LoadingScreen from "@/components/Loading";
import Heading from "@/src/console/(auth)/(check-assessments)/re-assessments/[id]/categories/[id]/_components/Heading";
import SubCategoryTable from "@/src/console/(auth)/_components/CheckingAssessment/SubCategoryTable";
import { AppsListRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function ReAssessmentCategoryDetail() {
  const { id, categoryId = "" } = useParams();
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      name: t("re-assessments"),
      href: "/console/re-assessments",
    },
    {
      name: t("assessment-details"),
      href: `/console/re-assessments/${id}`,
    },
    {
      name: t("categories"),
      href: `/console/re-assessments/${id}/categories/${categoryId}`,
    },
  ];

  const { data, isLoading } = useGetReAssessmentCategory(categoryId);

  if (isLoading || !data) return <LoadingScreen />;
  const { answer_sub_categories, content, is_checked } = data.data;

  return (
    <>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <AdminContentContainer
        bottomBar={<BottomBar backLink={`/console/re-assessments/${id}`} />}
      >
        <Heading
          content={content}
          isChecked={is_checked}
          subCategoryCount={answer_sub_categories.length}
        />
        <div className="m-6">
          <div className="flex flex-col gap-2">
            <div className="text-2xl font-bold">{t("sub-categories")}</div>
            <div className="flex gap-1 justify-start items-center">
              <AppsListRegular />
              <span>
                {answer_sub_categories.length} {t("sub-categories")}
              </span>
            </div>
          </div>
          <div className="mt-4">
            <SubCategoryTable data={answer_sub_categories} />
          </div>
        </div>
      </AdminContentContainer>
    </>
  );
}

export default ReAssessmentCategoryDetail;
